import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useAtom } from "jotai";
import { FC } from "react";
import { modalDeleteAccount } from "../../../atoms/atom";
import { AccountService } from "../../../services/AccountService";
import { AccountDTO } from "../../../types/AccountDTO";
import { useAlert } from "../../contextProviders/AlertProvider";

const ModalDeleteAccount: FC<Partial<AccountDTO>> = (account: Partial<AccountDTO>) => {
	const [open, setOpen] = useAtom(modalDeleteAccount);
	const { showAlert, showError } = useAlert();

	return (
		<Dialog
			open={open}
			onClose={() => setOpen(false)}
			id='modal-delete'
		>
			<DialogTitle>Apagar usuário</DialogTitle>
			<DialogContent>
				Você tem certeza que deseja excluir este usuário? Esta ação não poderá ser desfeita!
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setOpen(false)}>
					Fechar
				</Button>
				<Button color="error" onClick={() => deleteAccount()}>
					Excluir
				</Button>
			</DialogActions>
		</Dialog>
	);

	async function deleteAccount() {
		const service = new AccountService();
		let response = await service.deleteAccount(account.username || '');
		setOpen(false);
		if (response?.status === 200) {
			showAlert("Usuário removido", "success");
		} else {
			showError();
		}
	}
}

export default ModalDeleteAccount;